import { useNavigate, useParams } from "react-router-dom";
import { useAPI } from "../api/useAPI";
import { useAPIQuery } from "../api/useAPIQuery";
import { useOnAPISuccess } from "../api/useOnAPISuccess";
import { useToastOnAPIError } from "../api/useToastOnAPIError";
import { LOGGED_IN_HOME_PAGE } from "../config";
import { AppPage } from "../utils/AppPage";
import { TeamManage } from "./TeamManage";
import { useGetTeamById } from "./useGetTeamById";

export const TeamEditPage = () => {
  const api = useAPI();
  const { data, state, error, query } = useAPIQuery<"teamPut">({
    apiCall: api.teamPut,
  });
  const navigate = useNavigate();
  useToastOnAPIError({ title: "Unable to update team", error });
  useOnAPISuccess<"teamPut">({
    data,
    state,
    onSuccess: () => {
      navigate(LOGGED_IN_HOME_PAGE);
    },
  });
  const { teamId } = useParams();
  const [team] = useGetTeamById(teamId);
  return (
    <AppPage title={team ? `Edit Team "${team.name}"` : ""}>
      <TeamManage
        defaultTeam={team ?? undefined}
        isLoading={state === "loading"}
        submitButtonText={"Save"}
        onSubmit={(p) => {
          if (!team) {
            return;
          }
          query({
            id: team.id,
            ...(p.teamName !== team.name ? { name: p.teamName } : {}),
            ...(p.teamColor !== team.color ? { color: p.teamColor } : {}),
            ...(p.iconColor !== team.iconColor
              ? { iconColor: p.iconColor }
              : {}),
            ...(p.teamIcon !== team.iconType ? { iconType: p.teamIcon } : {}),
          });
        }}
      />
    </AppPage>
  );
};
